import { gql } from "@apollo/client";

// The logged-in user's Webtop layout. `data` is a JSON string of the layout
// object; the employee identity is derived server-side from the JWT.
export const GET_DESKTOP_LAYOUT = gql`
  query GetDesktopLayout {
    getDesktopLayout {
      employeeId
      data
      updatedAt
    }
  }
`;

export const SAVE_DESKTOP_LAYOUT = gql`
  mutation SaveDesktopLayout($data: String!) {
    saveDesktopLayout(data: $data) {
      employeeId
      data
      updatedAt
    }
  }
`;
